import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "../../components/ui/input";
import { staffApi, apiError } from "../../lib/staffApi";

export default function StaffLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await staffApi.post("/login", { email, password });
      nav("/staff", { replace: true });
    } catch (ex) { setErr(apiError(ex)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[var(--ink)] flex items-center justify-center p-6 font-en" data-testid="staff-login-page">
      <form onSubmit={submit} className="w-full max-w-sm bg-[#FFF9EE] rounded-3xl p-8 shadow-2xl space-y-5">
        <div className="flex items-center gap-3">
          <span className="w-11 h-11 rounded-full bg-[var(--ink)] text-amber-300 flex items-center justify-center"><Lock size={20} /></span>
          <div>
            <div className="font-brush text-3xl text-[var(--vermilion)] leading-none">小書童</div>
            <div className="text-sm text-stone-500">Admin Console</div>
          </div>
        </div>
        <label className="block text-sm text-stone-600 space-y-1"><span>Email</span>
          <Input data-testid="staff-login-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </label>
        <label className="block text-sm text-stone-600 space-y-1"><span>Password</span>
          <Input data-testid="staff-login-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {err && <div className="text-sm text-red-600" data-testid="staff-login-error">{err}</div>}
        <button data-testid="staff-login-submit" disabled={busy} className="w-full h-11 rounded-full bg-[var(--vermilion)] text-white font-semibold disabled:opacity-60">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
